(ns dashboard.services.questionnaire-list
  (:require [re-frame.core :as rf]
            [dashboard.ui :as ui]
            [dashboard.notifications :as notifications]
            [dashboard.services.http-config :as http-config]))

(defn add-questionnaire [db questionnaire]
  (update-in db [:questionnaire-list :data] conj questionnaire))

;; Events

(rf/reg-event-fx
  ::get
  (fn [{:keys [db]} [_ url-params after only-if-not-present]]
    (when (not (and only-if-not-present
                    (get-in db [:questionnaire-list :data])))
      {:db (update-in db [:questionnaire-list]
                      assoc
                      :loading true
                      :load-success false)
       :http-xhrio (cond-> {:method :get
                            :uri "/api/questionnaires/"
                            :response-format http-config/transit-response-format
                            :on-success [::get-success (:success after)]
                            :on-failure [::get-failure (:failure after)]}
                     url-params (assoc :url-params url-params))})))

(rf/reg-event-fx
  ::get-success
  (fn [{:keys [db]} [_ after questionnaires]]
    (cond-> {:db (assoc db :questionnaire-list {:loading false
                                                :load-success true
                                                :data questionnaires})}
      after (assoc :dispatch after))))

(rf/reg-event-fx
  ::get-failure
  (fn [{:keys [db]} [_ after]]
    {:db (assoc db :questionnaire-list {:loading false
                                        :load-success false})
     :fx (cond-> [[:dispatch [::notifications/add {:message  "Failed to get questionnaires"
                                                   :class "is-danger"}]]]
           after (conj [:dispatch after]))}))

(rf/reg-event-fx
  ::on-confirm-delete-questionnaire
  (fn [_ [_ questionnaire-id name]]
    {:http-xhrio {:method :delete
                  :uri (str "/api/questionnaires/" questionnaire-id)
                  :format http-config/transit-request-format
                  :response-format http-config/transit-response-format
                  :on-success [::delete-questionnaire questionnaire-id name]
                  :on-failure [::ui/set-error (str "Failed to delete questionnaire: " name)]}}))

(rf/reg-event-fx
  ::delete-questionnaire
  (fn [{:keys [db]} [_ questionnaire-id name]]
    {:db (update-in db [:questionnaire-list :data] #(remove (fn [questionnaire]
                                                              (= questionnaire-id (:id questionnaire)))
                                                            %))
     :dispatch [::notifications/add {:message (str "Deleted questionnaire: " name)}]}))

(rf/reg-event-fx
  ::toggle-question-answering
  (fn [{:keys [db]} [_ value]]
    {:db (assoc-in db [:show-question-answering] value)}))

;; Subs

(rf/reg-sub
  ::questionnaire-list
  (fn [db _]
    (:questionnaire-list db)))

(rf/reg-sub
  ::loading
  :<- [::questionnaire-list]
  (fn [questionnaire-list _]
    (:loading questionnaire-list)))

(rf/reg-sub
  ::data
  :<- [::questionnaire-list]
  (fn [questionnaire-list [_ pred]]
    (let [data (:data questionnaire-list)]
      (if pred
        (filter pred data)
        data))))

(rf/reg-sub
 ::present-question-answering
 (fn [db _]
   (get db :show-question-answering true)))
